/* istanbul ignore file */
import { takeLatest } from 'redux-saga/effects'
import { buildApiSaga } from 'commons/js/sagas/helpers'

import { REQUEST_RATES, UNAUTHORIZED_ERROR } from '../actions/types'
import { receiveRates } from '../actions/rates'
import * as api from 'commons/js/api'

function mapError (result) {
    if (result.error.name === UNAUTHORIZED_ERROR) {
        return {
            ...result,
            omitGlobalError: true,
        }
    }

    return result
}

export const fetchRates = buildApiSaga({
    request: api.searchRates,
    action: receiveRates,
    mapError,
})

export function * watchRates () {
    yield takeLatest(REQUEST_RATES, fetchRates)
}

export default watchRates
